import { useEffect, useState } from "react";

const NARROW_QUERY = "(max-width: 720px), (orientation: portrait)";

/** True on mobile/portrait widths — the same breakpoint used to swap desktop/mobile game assets everywhere. */
export default function useIsNarrow() {
  const [narrow, setNarrow] = useState(() => window.matchMedia(NARROW_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(NARROW_QUERY);
    const handler = () => setNarrow(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return narrow;
}
